/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodEmpty = createReactComponent("mood-empty", "IconMoodEmpty", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 10l.01 0", key: "svg-1" }],
  ["path", { d: "M15 10l.01 0", key: "svg-2" }],
  ["path", { d: "M9 15l6 0", key: "svg-3" }]
]);

export { IconMoodEmpty as default };
//# sourceMappingURL=IconMoodEmpty.js.map
